export default __webpack_public_path__ + "16bbb9b701336b18ed5c2b6cd29d5a9a.svg";